import React from 'react';
import { registerNetworkStatusCallback } from './registerNetworkStatusCallback';
import { ONLINE_THRESHOLD } from './OfflineLink';
export const NetworkStatusIndicator = ({ indicator: Indicator, }) => {
    const [networkStatus, setNewtorkState] = React.useState(true);
    React.useEffect(() => registerNetworkStatusCallback(ONLINE_THRESHOLD, setNewtorkState, 2000));
    return React.createElement(Indicator, { networkStatus: networkStatus });
};
